import React, { useState, useEffect } from "react";
import { api, eur } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useConfig } from "../context/ConfigContext";
import { MONTHS_IT, SEASON_MONTHS } from "../lib/season";
import { Package, Info, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Giacenze() {
  const { canWrite } = useAuth();
  const { config, save } = useConfig();
  const [inv, setInv] = useState({});
  const [saving, setSaving] = useState(null);

  const load = () => api.get("/inventory").then((r) => {
    const map = {};
    r.data.forEach((x) => { map[x.month] = x; });
    setInv(map);
  });
  useEffect(() => { load(); }, []);

  const saveMonth = async (m) => {
    const mstr = `2026-${String(m).padStart(2, "0")}`;
    setSaving(m);
    try {
      const value = Number(inv[mstr]?.value || 0);
      await api.post("/inventory", { month: mstr, value, note: inv[mstr]?.note || "" });
      toast.success(`Giacenza ${MONTHS_IT[m]} salvata`);
      load();
    } catch (e) { toast.error("Errore"); }
    finally { setSaving(null); }
  };

  const toggleUse = async (v) => {
    await save({ use_inventory: v });
    toast.success(v ? "Giacenze attivate" : "Giacenze disattivate");
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-navy">Giacenze cambusa</h1>
        <p className="text-slate-500">Valore stimato della cambusa a fine mese (~10 min/mese)</p>
      </div>

      <div className="flex items-start gap-3 rounded-xl border border-gold/40 bg-gold/10 p-4">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
        <div className="text-sm text-navy">
          <p className="mb-2">Il food cost <b>reale</b> = (giacenza iniziale + acquisti − giacenza finale) ÷ coperti. Senza giacenze si usa la sola approssimazione spesa÷coperti.</p>
          {canWrite && (
            <label className="flex cursor-pointer items-center gap-2 font-semibold">
              <input data-testid="toggle-inventory" type="checkbox" checked={!!config?.use_inventory} onChange={(e) => toggleUse(e.target.checked)} className="h-5 w-5 accent-gold" />
              Usa le giacenze nel calcolo food cost
            </label>
          )}
        </div>
      </div>

      <div className="space-y-3">
        {SEASON_MONTHS.map((m) => {
          const mstr = `2026-${String(m).padStart(2, "0")}`;
          const row = inv[mstr] || { value: "" };
          return (
            <div key={m} data-testid={`inventory-${m}`} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4">
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy/10 text-navy"><Package className="h-5 w-5" /></div>
              <div className="flex-1">
                <div className="font-head font-semibold text-navy">{MONTHS_IT[m]} 2026</div>
                <div className="text-xs text-slate-400">Valore cambusa a fine mese</div>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-slate-400">€</span>
                <input
                  data-testid={`inventory-value-${m}`}
                  type="number"
                  step="0.01"
                  disabled={!canWrite}
                  value={row.value}
                  onChange={(e) => setInv({ ...inv, [mstr]: { ...row, value: e.target.value } })}
                  className="tnum h-12 w-28 rounded-lg border-2 border-slate-200 px-2 text-right outline-none focus:border-gold disabled:bg-slate-100"
                  placeholder="0.00"
                />
              </div>
              {canWrite && (
                <button data-testid={`save-inventory-${m}`} onClick={() => saveMonth(m)} disabled={saving === m} className="flex h-12 items-center gap-1 rounded-lg bg-navy px-4 text-sm font-semibold text-white hover:bg-navy-hover disabled:opacity-60">
                  {saving === m && <Loader2 className="h-4 w-4 animate-spin" />} Salva
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
